export default __webpack_public_path__ + "static/1139-5f4339cedd93f8f422743ba280bd19d8.gif";